import React, { Component } from 'react'
import axios from "axios";
import Path from "./config";
import logoreg from "../abc.png";

class LevaTermsAndCondition extends Component {
    constructor(props) {
        super(props);

        this.state = {
            terms_heading: '',
            terms_disc: '',


        }
    }
    componentDidMount() {



        // ********************** education ************************
        axios.get(Path + 'suchi_term_condition.php')
            .then(function (response) {
                // console.log("rrrrrrrrrrrrrrrrrrrrrr", response.data);
                this.setState({
                    terms_heading: response.data.bg_cast[1].term_title,
                    terms_disc: response.data.bg_cast[1].term_desc
                })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });

    }
    cancleClick = () => {
        this.props.history.push(`/`);
    }

    render() {


        return (
            <>
                <div className="container-fluid">
                    <span className="align-middle d-flex justify-content-center">
                        <img src={logoreg} alt="logo" style={{ width: "300px" }}></img>
                    </span>
                    <div className="row justify-content-md-center my-5 ">

                        <div className="col-md-8 border  border-5 p-3 mb-2 bg-light text-dark">
                            <div className="mb-3  ">
                                <span className="d-block p-2 bg-danger text-white text-md-center text-capitalize">
                                    <div dangerouslySetInnerHTML={{ __html: this.state.terms_heading }} />
                                </span>
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: this.state.terms_disc }} />
                            <div className="mb-3 text-center my-5">

                                <button type="button" className="btn btn-primary" onClick={() => this.cancleClick()}> Cancel ❎ </button>
                            </div>

                        </div>
                    </div>

                </div>

            </>
        )
    }
}

export default LevaTermsAndCondition
